import type { PaginatedListResponseApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { AssetResourceReadV2ApiFront } from './asset.model';

export enum OsResourceStatus {
  PUBLISHED = 'PUBLISHED',
  DEPRECATED = 'DEPRECATED',
}

export const enumOsResourceStatus = {
  PUBLISHED: 'PUBLISHED',
  DEPRECATED: 'DEPRECATED',
};

export interface OsResourceApiMapped {
  readonly compatibleDeviceFamilyNames?: string[];
  readonly creationDate?: Date;
  readonly id: string;
  readonly name?: string;
  readonly osVersionIds?: string[];
  readonly publishedVersionNumbers?: string[];
  readonly publisherId?: string;
  readonly status?: OsResourceStatus;
  readonly assets: AssetResourceReadV2ApiFront[];
}

export interface OsListResponseApiMapped extends PaginatedListResponseApi {
  readonly data: OsResourceApiMapped[];
}
